import { gsap } from "gsap";

export default class scrollHeader {
  constructor() {
    this.$header = document.querySelector(".l-header");
    this.$trigger = document.getElementById("l-header__checkbox");
    this.$detail = document.querySelectorAll(".js-header-detail");
    this.startPos = 0;
    this.winScrollTop = 0;
    this.scrollTop = 0;
    this.init();
    this.closingAnim = (content, element) =>
      gsap.to(content, {
        height: 0,
        opacity: 0,
        duration: 0.4,
        ease: "power3.out",
        overwrite: true,
        onComplete: () => {
          element.removeAttribute("open");
        },
      });
    this.openingAnim = (content) =>
      gsap.fromTo(
        content,
        {
          height: 0,
          opacity: 0,
        },
        {
          height: "auto",
          opacity: 1,
          duration: 0.4,
          ease: "power3.out",
          overwrite: true,
        }
      );
  }
  init() {
    this.setSummary();
    window.addEventListener(
      "scroll",
      () => {
        this.winScrollTop = window.scrollY || window.pageYOffset;
        if (
          this.winScrollTop > this.startPos &&
          this.winScrollTop != 0 &&
          this.winScrollTop > 0
        ) {
          this.$header.classList.add("is-active");
        } else {
          this.$header.classList.remove("is-active");
        }
        this.startPos = this.winScrollTop;
      },
      false
    );
    this.$trigger.addEventListener("change", () => {
      if (this.$trigger.checked) {
        this.bodyFixedOn();
      } else {
        this.bodyFixedOff();
      }
    });
    window.addEventListener("resize", () => {
      this.setSummary();
    });
  }
  setSummary() {
    if (window.innerWidth < 768) {
      this.$detail.forEach((element, index) => {
        element.removeAttribute("open");
      });
    } else {
      this.$detail.forEach((element, index) => {
        element.setAttribute("open", true);
      });
    }
    this.setAccordion();
  }
  setAccordion() {
    const details = document.querySelectorAll(".js-header-detail");
    const IS_OPENED_CLASS = "is-opened";

    details.forEach((element) => {
      const summary = element.querySelector(".js-summary");
      const content = element.querySelector(".js-content");
      if (window.innerWidth > 768) {
        event.preventDefault();
      }
    });
    /*
    const details = document.querySelectorAll(".js-header-detail");
    const IS_OPENED_CLASS = "is-opened";
    if (window.innerWidth < 768) {
      details.forEach((element) => {
        const summary = element.querySelector(".js-summary");
        const content = element.querySelector(".js-content");

        summary.addEventListener("click", (event) => {
          event.preventDefault();
          if (element.classList.contains(IS_OPENED_CLASS)) {
            element.classList.toggle(IS_OPENED_CLASS);
            this.closingAnim(content, element).restart();
          } else {
            element.classList.toggle(IS_OPENED_CLASS);
            element.setAttribute("open", "true");
            this.openingAnim(content).restart();
          }
        });
      });
    } else {
      details.forEach((element) => {
        const summary = element.querySelector(".js-summary");
        summary.removeEventListener("click");
      });
    }
    */
  }
  bodyFixedOn() {
    this.scrollTop = window.scrollY;
    const $body = document.querySelector("body");
    $body.style.position = "fixed";
    $body.style.top = -this.scrollTop + "px";
  }

  bodyFixedOff() {
    const $body = document.querySelector("body");
    $body.style.position = "static";
    $body.style.top = "";
    window.scrollTo(0, this.scrollTop);
  }
}
